import { render, staticRenderFns } from "./PreviewsPerTaskType.vue?vue&type=template&id=6b6c8874&scoped=true&"
import script from "./PreviewsPerTaskType.vue?vue&type=script&lang=js&"
export * from "./PreviewsPerTaskType.vue?vue&type=script&lang=js&"
import style0 from "./PreviewsPerTaskType.vue?vue&type=style&index=0&id=6b6c8874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c8874",
  null
  
)

export default component.exports